<template>
 <div class="container" v-if="isShow">
      <div class="mask"></div>
      <div class="box">
           <p class="tip1">上报审核</p>
           <p class="tip2">审核通过后将继续下一步</p>
           <p class="tip3">状态变成已审核</p>
           <div class="btn">
                <span class="left" @click="sell">拒绝</span>
                <span class="right" @click="confirm">确定</span>
           </div>
      </div>
 </div>
</template>
<script>
    export default {
        data () {
            return {
                isShow: false
            }
        },
        created () {

        },
        methods: {
            showBox () {
                this.isShow = true;
            },
            confirm () { // 关注
                this.isShow = false;
                this.$emit('sendReview')
            },
            sell () {
                this.isShow = false;
                this.$router.push('noReview');
            }
        }
    }
</script>
<style  lang="less" scoped>
.container{
    width:100%;
    height:100%;
    // position: absolute;
    // left:0;
    // top:0;
    // z-index: 20;
    // background-color: pink;
    .mask{
        width:100%;
        height:100%;
        position: fixed;
        left:0;
        top:0;
        z-index: 20;
        background: rgba(0,0,0,.5);
    }
    .box{
        position: fixed;
        width:260px;
        // height:200px;
        padding:30px 0 30px 0;
        background: #fff;
        left:50%;
        top:50%;
        transform: translate(-50%,-50%);
        z-index: 30;
        text-align: center;
        border-radius: 6px;
        .tip1{

            font-size:18px;
            color:#000;
            margin-top:30px;
        }
        .tip2{

            font-size:14px;
            color:#B7B7B7;
            margin-top:30px;
            margin-top:16px;
        }
        .tip3{

            font-size:14px;
            color:#B7B7B7;
            margin-top:30px;
            margin-top:12px;
        }
        .btn{
            width:100%;
            padding:0 15px;
            display: flex;
            display: -webkit-flex;
            justify-content: space-between;
            flex-direction: row;
            margin-top:30px;
            .left{
                width:100px;
                height:40px;
                border:1px solid #CCCCCC;
                text-align: center;
                line-height: 40px;
                font-size:15px;
                color:#CCCCCC;
            }
            .right{
                width:100px;
                height:40px;
                background: @base-color;
                color:#fff;
                text-align: center;
                line-height: 40px;
                font-size:15px;
            }
        }
    }
}
</style>
